import React from 'react';
import { UTILS } from '../../constants';
import axios from 'axios';

export const Join = ({ members, setMembers, cardDetail }) => {
  // Retrieve user details from localStorage
  let getUserDetailsData =
    JSON.parse(localStorage.getItem('userDetails')) || {};
  // console.log("members",members);

  // Function to handle adding the short name to members array
  const handleJoin = (id) => {
    // Check if the id does not exist in members array
    const memberExists = members && members?.some((member) => member.id === id);
    if (!memberExists) {
      const randomString = Math.random().toString(36).substring(2, 5);
      const formData = new FormData();
      formData.append('task_id', cardDetail.id);
      formData.append('member_id', id);
      formData.append('assigned', 1);
      axios
        .post(
          `${UTILS.API_url}board/v1/board-list-cards/assign-unassign-member?${randomString}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then((response) => {
          // console.log("responseresponse.data.assigned_users",response);

          setMembers([...members, getUserDetailsData]);

          // console.log("Member_successfully:", response.data.assigned_users);
          // setUpdateAssign(response.data.board_list_card);
          // toast.success(response.data.success);
        })
        .catch((error) => {
          console.error('Error assigning/unassigning member:', error);
        });
    }
  };
  //   const handleAssignMember = (memberId, assignId) => {
  //     const randomString = Math.random().toString(36).substring(2, 5);
  //     const formData = new FormData();
  //     formData.append("task_id", cardDetail.id);
  //     formData.append("member_id", memberId);
  //     formData.append("assigned", assignId);
  //     axios
  //       .post(
  //         `${UTILS.API_url}board/v1/board-list-cards/assign-unassign-member?${randomString}`,
  //         formData,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         setAssigned_users(response.data.assigned_users);
  //         setUnassigned_users(response.data.unassigned_users);
  //         updateMemnbers(response.data.assigned_users);

  //         // console.log("Member_successfully:", response.data.assigned_users);
  //         // setUpdateAssign(response.data.board_list_card);
  //         // toast.success(response.data.success);
  //       })
  //       .catch((error) => {
  //         console.error("Error assigning/unassigning member:", error);
  //       });
  //   };
  // Determine if the user already exists in the members list
  const memberExists =
    members && members.some((member) => member.id === getUserDetailsData?.id);

  return (
    <div>
      <div className="client-details">
        {cardDetail?.client?.name ? (
          <>
            <h4 className="description-heading">Client Details</h4>
            <p className="popup-client-details">
              <span className="detailTeam">{cardDetail?.client?.name}</span>
            </p>
          </>
        ) : (
          ''
        )}
        {cardDetail?.team ? (
          <div>
            <h4 className="description-heading">Team Details</h4>
            <p className="popup-client-details">
              <span className="detailTeam">{cardDetail?.team?.name}</span>
              <span className="detailTeam">
                {cardDetail?.board_list?.department?.name}
              </span>
            </p>
          </div>
        ) : null}
      </div>
      {!cardDetail?.deleted_at && (
  <>
    {/* {console.log("joined", cardDetail)} */}
    {!memberExists && <h4>Suggested</h4>}
    <ul>
      {!memberExists && (
        <li>
          <a
            className="assign-own-members"
            href="javascript:void(0);"
            onClick={() => handleJoin(getUserDetailsData?.id)}
          >
            <span className="material-symbols-outlined">person</span> Join
          </a>
        </li>
      )}
    </ul>
  </>
)}

    </div>
  );
};
